module.exports = __webpack_public_path__ + "img/map.f072c5fc.svg";